import Vue from 'vue'
import Vuex from 'vuex';
import SiteSchemaEditorModule from '../vue/site-schema-editor/vuex/store';
import SiteConfigurationToolModule from '../vue/site-configuration-tool/vuex/store';
import BatteryStateModule from '../vue/battery-controls/vuex/store';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        siteSchemaEditor: SiteSchemaEditorModule,
        siteConfigurationTool: SiteConfigurationToolModule,
        batteryState: BatteryStateModule
    }
});

export default store;
